
export const ShowMessage = (
    {
        title, 
        message, 
        typeMessage = 'success', 
        showCancelButton = false,
        confirmButtonText =  'Aceptar',
        cancelButtonText = 'Cancelar',
        callbackConfirm,
        callbackclickoutofplace,
        html
    }) =>{
    
    const Swal = require('sweetalert2');
    
    Swal.fire({
        title,
        text: message,
        icon: typeMessage,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        html
    })
    .then((result) =>{
        if( result.isConfirmed ){
            if( callbackConfirm ){
                callbackConfirm();
            }
        }else{
            if( callbackclickoutofplace ){
                callbackclickoutofplace();
            }
        }
    });

    return Swal;
}